export default "__VITE_ASSET__CdhKg_Gj__"